<template>
  <base-panel
    v-show="courseList.length"
    :title="title"
    class="base-panel"
    @toMore="redirectAuthorPage(courseList[0].authorId)"
  >
    <ul class="courses">
      <li v-for="item in courseList" :key="item.setId" class="course">
        <router-link
          class="course-icon"
          :style="{ backgroundImage: `url(${item.coverImagUrl})` }"
          :to="`/course/${item.setId}`"
        >
        </router-link>
        <div class="course-right">
          <router-link class="name" :to="`/course/${item.setId}`">
            {{
              item.title.length > 10
                ? item.title.substring(0, 10) + '...'
                : item.title
            }}</router-link
          >
          <div class="bottom">
            <div class="course-sales">￥{{ item.price }}/套</div>
            <div class="people-buy-count">{{ item.saledCount }}人购买</div>
          </div>
        </div>
      </li>
    </ul>
  </base-panel>
</template>

<script>
import BasePanel from '@/components/BasePanel/BasePanel'

export default {
  name: 'CoursePanel',
  components: { BasePanel },
  props: {
    courseList: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    redirectAuthorPage(authorId) {
      this.$router.push({
        path: '/author/' + authorId,
        query: { activeTab: 2 }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-panel {
  flex-direction: column;
}
.courses {
  padding: 15px 0;
}

.course {
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 20px;
  padding-left: 20px;
}

.course-icon {
  width: 100px;
  height: 75px;
  background: no-repeat center;
  background-size: cover;
  margin-right: 10px;
}
.course-right {
  height: 75px;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: auto;
}
.name {
  padding-top: 10px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
  text-decoration: none;
}

.course-sales {
  position: absolute;
  bottom: 8px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #e64c2e;
}
.people-buy-count {
  position: absolute;
  right: 20px;
  bottom: 8px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #858585;
}
</style>
